import { writable } from 'svelte/store';

export type AnchorNavigationStoreEntry = {
  el: HTMLSpanElement;
  text: string;
  markKey: string | undefined;
  addToAnchorNavigationBar: boolean;
};

export type AnchorNavigationStore = {
  offset: number;
  anchors: AnchorNavigationStoreEntry[];
};

function createAnchorNavigationStore() {
  const { subscribe, update } = writable<AnchorNavigationStore>({ offset: 0, anchors: [] });

  function setOffset(newOffset: number) {
    update((state) => ({ ...state, offset: newOffset }));
  }

  function registerAnchor(entry: AnchorNavigationStoreEntry) {
    update((state) => ({
      ...state,
      anchors: [...state.anchors, entry]
    }));
  }

  function removeAnchor(entryEl: HTMLSpanElement) {
    update((state) => ({
      ...state,
      anchors: state.anchors.filter((anchor) => anchor.el !== entryEl)
    }));
  }

  return {
    subscribe,
    setOffset,
    registerAnchor,
    removeAnchor
  };
}

export const anchorNavigationStore = createAnchorNavigationStore();
